// extracted by mini-css-extract-plugin
export var btn = "button-module--btn--34de0";
export var btnWrapper = "button-module--btnWrapper--070e7";
export var button = "button-module--button--5e461";
export var extraSmallButton = "button-module--extraSmallButton--58ef1";
export var largeButton = "button-module--largeButton--7d73a";
export var mediumButton = "button-module--mediumButton--a297d";
export var secondaryButton = "button-module--secondaryButton--0da8c";
export var smallButton = "button-module--smallButton--6c815";
export var tertiaryButton = "button-module--tertiaryButton--854e8";